import { AfterContentInit, Component, ContentChildren, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild } from '@angular/core';

import { WizardStepComponent } from './wizard-step/wizard-step.component';

@Component({
	selector: 'ac-wizard',
	templateUrl: './wizard.component.html',
	styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit, OnChanges, AfterContentInit {
	@Input() public title: string;
	@Input() public finalStepName: string;
	@Input() public stepIndex: number = 0;
	@Input() public showStepper: boolean = true;
	@Input() public showHeader: boolean = true;
	@Input() public showFooterActions: boolean = true;
	@Input() public adaptToContentSize: boolean = false;
	@Input() public contentHeight: string;
	@Input() public showCustomStepper: boolean = false;
	@Input() public shouldUpdateFinalStepIndex: boolean = true;
	@Input() public isImportFlow: boolean = false;

	@Output() public stepIndexChange: EventEmitter<number> = new EventEmitter<number>();
	@Output() public finalStepAction: EventEmitter<any> = new EventEmitter<any>();
	@Output() public dontShowAgainAction: EventEmitter<any> = new EventEmitter<any>();

	@ContentChildren(WizardStepComponent) public stepComponents: QueryList<WizardStepComponent>;
	@ViewChild('content', { static: true }) public contentElement: ElementRef;

	public stepComponentsArr: WizardStepComponent[];

	public ngOnInit(): void {
		const customizedContentHeight = this.contentHeight || '425px';
		this.contentHeight = this.adaptToContentSize ? 'auto' : customizedContentHeight;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.stepIndex && !changes.stepIndex.isFirstChange()) {
			this.navigateToStep(changes.stepIndex.currentValue);
		}
	}

	public ngAfterContentInit(): void {
		this.stepComponentsArr = this.stepComponents.toArray();
		this.navigateToStep(this.stepIndex);
	}

	public nextStep(): void {
		if (this.stepIndex < this.stepComponentsArr.length - 1) {
			this.navigateToStep(this.stepIndex + 1);
		}
	}

	public prevStep(): void {
		if (this.stepIndex > 0) {
			this.navigateToStep(this.stepIndex - 1);
		}
	}

	public navigateToStep(index: number): void {
		this.contentElement.nativeElement.scrollTop = 0;
		this.stepIndex = index;
		this.stepComponentsArr.forEach((step, i) => (step.isSelected = this.stepIndex === i));
		this.stepIndexChange.emit(this.stepIndex);
	}

	public lastStep(): void {
		// Emit the changes when the last step has been completed
		this.finalStepAction.emit();
		if (this.shouldUpdateFinalStepIndex) {
			this.stepIndex = 0;
		}
	}

	public dontShowAgainStep(): void {
		// Emit the don't show again button is clicked
		this.dontShowAgainAction.emit();
		this.stepIndex = 0;
	}
}
